import { BaseRouteService } from 'core/services';

class PatientRouteService extends BaseRouteService {
    constructor() {
        super('patients');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,firstName,lastName,dateOfBirth,facilityId,firstOrLastName}', filter);
    }

    findPatients(filter) {
        return super.find(this.base + '/extended/{?searchQuery,page,rpp,sort,firstName,lastName,dateOfBirth,ssn}', filter);
    }

    get(id) {
        return super.get(this.base + '/{id}', id);
    }

    getPatientPrimaryInsurance(id) {
        return super.get(this.base + '/{id}/primary-insurance', id);
    }

    createBrightreeAndLocalPatientAndInitializeTemplate() {
        return super.create(this.base + '/create-bt-and-local-patient-and-initialize-template');
    }

    updatePatientInsurance(resource) {
        return super.update(`${this.base}/update-patient-insurance`, resource);
    }

    updatePatientDetails(resource) {
        return super.update(`${this.base}/update-patient-details`, resource);
    }

    updateOrderingDoctor(resource) {
        return super.update(`${this.base}/update-ordering-doctor`, resource);
    }

    updatePatientInsuranceNewFlow(resource) {
        return super.update(`${this.base}/update-patient-insurance-new-flow`, resource);
    }
}

export default PatientRouteService;
